module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_03_spectacular_spot-21a73b85857cd1129e8d0b766a3ef9b9.jpg";